import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';

@Component({
  selector: 'app-tentou-master-dialog',
  templateUrl: './tentou-master-dialog.component.html',
  styleUrls: ['./tentou-master-dialog.component.scss']
})
export class TentouMasterDialogComponent implements OnInit {
  public meisai: any = {};
  title = '';
  startShuurei = '';
  endShuurei = '';
  tentouJikan = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public commonService: CommonService,
              public matDialogRef: MatDialogRef<TentouMasterDialogComponent>,) { }

  /**
   *
   */
  ngOnInit(): void {
    console.log('dialog ngOnInit works!');
    if (this.data.meisai.tentouShoutouJikoku?.length) {
      // 既存データ編集時
      this.meisai = this.data.meisai;
    } else {
      // 新規作成時
      this.meisai = {startNichirei: 1, endNichirei: 7, tentouShoutouJikoku: [{start: '00:00', end: '00:00'}], hover: true, toDelete: false};
    }
    this.title = '点灯プログラム追加・修正';
    this.nichireiToShuurei(this.meisai.startNichirei, 'start');
    this.nichireiToShuurei(this.meisai.endNichirei, 'end');
    this.genTentouJikan();
  }

  /**
   *
   * @param nichirei
   * @param startOrEnd
   */
  nichireiToShuurei(nichirei: number, startOrEnd: 'start' | 'end'): void {
    if (!nichirei) {
      startOrEnd === 'start' ? this.startShuurei = '' : this.endShuurei = '';
      return;
    }
    const week = Math.floor((nichirei - 1) / 7);
    const day = (nichirei - 1) % 7 + 1;
    switch (startOrEnd) {
      case 'start':
        this.startShuurei = String(week) + 'W' + String(day) + 'D';
        break;
      case 'end':
        this.endShuurei = String(week) + 'W' + String(day) + 'D';
        break;
    }
  }

  /**
   *
   * @param shuurei
   * @param startOrEnd
   */
  shuureiToNichirei(shuurei: string, startOrEnd: 'start' | 'end'): void {
    const exp = /^\d+W\d+D$/g;
    if (shuurei.match(exp)) {
      const w = Number(shuurei.replace('D', '').split('W')[0]);
      const d = Number(shuurei.replace('D', '').split('W')[1]);
      switch (startOrEnd) {
        case 'start':
          this.meisai.startNichirei = 7 * w + d;
          break;
        case 'end':
          this.meisai.endNichirei = 7 * w + d;
          break;
      }
    }
  }

  /**
   *
   */
  genTentouJikan() {
    this.tentouJikan = this.commonService.genTimeDiffString(this.meisai.tentouShoutouJikoku[0].start, this.meisai.tentouShoutouJikoku[0].end);
  }
}
